/**
 * Header Block - Frontend JavaScript
 * mobile menu toggle
 */

 
function init() {
  // Find all header blocks
  const headers = document.querySelectorAll('.wp-block-papa-lp-header');

  headers.forEach((header) => {
    // Skip if already initialized
    if (header.dataset.initialized === '1') return;


    // Mobile menu toggle
    const menuToggle = header.querySelector('.header__menu-toggle');
    const mobileMenu = header.querySelector('.header__mobile-menu');
    const links = mobileMenu.querySelectorAll('a');
    
    if (menuToggle && mobileMenu) {
      menuToggle.addEventListener('click', () => {
        toggleMenu();
      });
      links.forEach((link) => {
        link.addEventListener('click', () => {
          toggleMenu();
        });
      });
    }
 
    // Mark as initialized
    header.dataset.initialized = '1';


    function toggleMenu() {
      const isOpen = header.classList.contains('header--menu-open');

      if (isOpen) {
        header.classList.remove('header--menu-open');
        menuToggle.setAttribute('aria-expanded', 'false');
        mobileMenu.setAttribute('aria-hidden', 'true');
      } else {
        header.classList.add('header--menu-open');
        menuToggle.setAttribute('aria-expanded', 'true');
        mobileMenu.setAttribute('aria-hidden', 'false');
      }
    }

  });
}




// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

// Export for manual re-initialization
window.PapaLpHeaderInit = init;

